import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import FieldFileUploadControl from './fields/FieldFileUploadControl';
import FieldColorPickerControl from './fields/FieldColorPickerControl';
import FieldInputControl from './fields/FieldInputControl';
import FieldTextAreaControl from './fields/FieldTextAreaControl';
import FieldRichTextEditor from '../editor/FieldRichTextEditor';

const onChangeValue = (setFieldValue, name, onChangeCallBack) => value => {
	onChangeCallBack && onChangeCallBack(value);
	return setFieldValue(name, value);
};

const CONTROLS_MAP = {
	upload: FieldFileUploadControl,
	colorpicker: FieldColorPickerControl,
	input: FieldInputControl,
	'text-area': FieldTextAreaControl,
	editor: FieldRichTextEditor
};

const FieldWrapperComponent = forwardRef((props, ref) => {
	const {
		control,
		field,
		form: { getFieldMeta, setFieldValue },
		onChangeCallBack,
		...others
	} = props;
	const input = {
		...field
	};
	const Component = CONTROLS_MAP[control] || FieldFileUploadControl;
	if (Component !== FieldInputControl) {
		input.onChange = onChangeValue(setFieldValue, field.name, onChangeCallBack);
	}
	// input.onChange = onChangeValue(setFieldValue, field.name, onChangeCallBack);

	const meta = getFieldMeta(field.name);
	return <Component ref={ref} formik input={input} meta={meta || {}} {...others} />;
});

FieldWrapperComponent.defaultProps = {
	control: 'upload'
};

FieldWrapperComponent.propTypes = {
	control: PropTypes.oneOf(Object.keys(CONTROLS_MAP)),
	field: PropTypes.object,
	form: PropTypes.object,
	meta: PropTypes.object,
	onChangeCallBack: PropTypes.func
};
export default FieldWrapperComponent;
